import AccesCROP from "./views/AccesCROP";
import AccesRespParcours from "./views/AccesRespParcours";
import BaseError from "./views/base/BaseError";
import DemandeAcces from "./views/DemandeAcces";
import DonneesPersonnelles from "./views/DonneesPersonnelles";
import DemandesEnCours from "./views/DemandesEnCours";
import DemandesFinalisees from "./views/DemandesFinalisees";
import DossiersAFinaliser from "./views/DossiersAFinaliser";
import Formulaire from "./views/Formulaire";
import RecevabiliteDesDemandes from "./views/RecevabiliteDesDemandes";
export default {
  definition: [
    // définition des routes :
    /**
     * - path: chemin relatif
     * - name: nom identifiant la route (unique)
     * - icon: icône materiel-design pour le lien dans le menu
     * - title: titre du lien dans le menu
     *
     * - meta: {
     *
     *   - title: titre de la page (balise <title> du <head> HTML)
     *   - menu: doit apparaître dans le menu
     *
     *   - access:
     *     - type: "public" | "anonymous" | "authenticated" | "authorized"
     *        "public"        => Page accès anonyme : toujours présente
     *        "anonymous"     => Page accès anonyme uniquement : présente uniquement si utilisateur non connecté
     *        "authenticated" => Page authentifiée : présente si utilisateur connecté et a les droits pour cela
     *     - roles: si route "authorized", liste des roles user ayant accès à cette route
     *   }
     * }
     */
    {
      /* PHARMACIEN (demande d'accès) */
      path: "/",
      name: "demande-acces",
      icon: "dashboard",
      title: "Demande d'accès",
      component: DemandeAcces,
      meta: {
        title: "Demande d'accès",
        menu: true,
        access: {
          type: "anonymous"
        }
      }
    },
    {
      /* PHARMACIEN (demande d'accès) */
      path: "/donnees-personnelles",
      name: "donnees-personnelles",
      icon: "dashboard",
      title: "Informations relatives à l'utilisation des données personnelles",
      component: DonneesPersonnelles,
      meta: {
        title:
          "Informations relatives à l'utilisation des données personnelles",
        menu: false,
        access: {
          type: "anonymous"
        }
      }
    },
    {
      /* PHARMACIEN (accès au formulaire) */
      path: "/dossier/:iddossier",
      name: "formulaire",
      icon: "dashboard",
      title: "Formulaire",
      component: Formulaire,
      meta: {
        title: "Formulaire",
        menu: false,
        access: {
          type: "public"
        }
      }
    },
    {
      /* PHARMACIEN (accès au formulaire) */
      path: "/dossier/:iddossier/part/:part",
      name: "formulaire-part",
      icon: "dashboard",
      title: "Formulaire-part",
      component: Formulaire,
      meta: {
        title: "Formulaire",
        menu: false,
        access: {
          type: "public"
        }
      }
    },
    /* PHARMA-SCOL/DOYEN */
    {
      path: "/recevabilite-des-demandes",
      name: "recevabilite-des-demandes",
      icon: "mdi-file-account",
      title: "Recevabilité des demandes",
      component: RecevabiliteDesDemandes,
      meta: {
        title: "Recevabilité des demandes",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_REPRESENTANT_DOYEN"]
        }
      }
    },
    /* PHARMA-SCOL/DOYEN */
    {
      path: "/demandes-en-cours",
      name: "demandes-en-cours",
      icon: "mdi-restart",
      title: "Demandes en cours d'études",
      component: DemandesEnCours,
      meta: {
        title: "Demandes en cours",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_REPRESENTANT_DOYEN"]
        }
      }
    },
    /* PHARMA-SCOL/DOYEN */
    {
      path: "/dossiers-a-finaliser",
      name: "dossiers-a-finaliser",
      icon: "mdi-sticker-alert-outline",
      title: "Demandes à finaliser",
      component: DossiersAFinaliser,
      meta: {
        title: "Demandes à finaliser",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_REPRESENTANT_DOYEN"]
        }
      }
    },
    /* PHARMA-SCOL/DOYEN */
    {
      path: "/demandes-finalisees",
      name: "demandes-finalisees",
      icon: "mdi-check-outline",
      title: "Demandes finalisées",
      component: DemandesFinalisees,
      meta: {
        title: "Demandes finalisées",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_REPRESENTANT_DOYEN"]
        }
      }
    },
    /* CROP */
    {
      path: "/crop",
      name: "crop",
      icon: "security",
      title: "Accès CROP",
      component: AccesCROP,
      meta: {
        title: "Accès CROP",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_CROP"]
        }
      }
    },
    /* RESPONSABLE DE PARCOURS */
    {
      path: "/resp-parcours",
      name: "resp-parcours",
      icon: "security",
      title: "Accès Responsable du parcours",
      component: AccesRespParcours,
      meta: {
        title: "Accès Responsable du parcours",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_RESPONSABLE_PARCOURS"]
        }
      }
    },
    {
      path: "/erreur",
      name: "erreur",
      component: BaseError,
      props: {
        message: "Une erreur est survenue"
      },
      meta: {
        title: "Page d'erreur",
        menu: false,
        access: {
          type: "public"
        }
      }
    },
    {
      path: "*",
      name: "notfound",
      component: BaseError,
      props: {
        message: "La page spécifiée est introuvable"
      },
      meta: {
        title: "Page non trouvée",
        menu: false,
        access: {
          type: "public"
        }
      }
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: BaseError,
      props: {
        message: "Vous n'êtes pas autorisé à accéder à cette page"
      },
      meta: {
        title: "Ressource non autorisée",
        menu: false,
        access: {
          type: "public"
        }
      }
    }
  ]
};
